/** Sidebar / main pane: live NWS weather page. */
export const ROUTE_WEATHER = '__weather__';

/** Sidebar / main pane: Reddit news aggregator. */
export const ROUTE_NEWS = '__news__';

/** Sidebar / main pane: daily briefing HTML iframe. */
export const ROUTE_DAILY = '__daily__';

/** Sidebar / main pane: ear training (melody play + reveal). */
export const ROUTE_EAR_TRAINING = '__ear_training__';

/** Sidebar: in-browser chess (Chessground + Stockfish). */
export const ROUTE_CHESS = '__chess__';

/** Tools → encrypt text and copy link (nothing saved to GitHub). */
export const ROUTE_TOOLS_ENCRYPT = '__tools_encrypt__';

/** Tools → app config (translation settings; localStorage only). */
export const ROUTE_CONFIG = '__config__';

/** Tools → import device localStorage backup. */
export const ROUTE_CONFIG_IMPORT = '__config_import__';

/** Sidebar → Cursor Cloud Agent chat (via Netlify proxy). */
export const ROUTE_CURSOR_AGENT = '__cursor_agent__';
